/* SWB v2 - ONE PRODUCT INFO SHEET (2026-10-15, asked: "the upsell products under 'Hier al aan gedacht?' get the same
   pop-up as the bundle builder, with the pros and cons from the metafield; the bundle builder's pop-up shows them too").
   A bottom sheet on phones, a card on desktop, in the bundle builder's look. It opens at once with what the row knows
   (photo, title, price) and fills in the pros and cons (custom.pro_s / custom.product_cons, read through the
   upp-product-facts section in the market's own language); the description only when a product has neither.
   window.swbV2InfoSheet.open({ handle, url, title, img, priceHtml }) */
(function () {
  if (window.swbV2InfoSheet) return;
  var L = String(document.documentElement.lang || 'nl').slice(0, 2);
  var T = {
    nl: { pros: 'Voordelen', cons: 'Nadelen', view: 'Bekijk product', close: 'Sluiten', add: 'In winkelwagen', added: 'Toegevoegd', err: 'Lukt niet, probeer opnieuw', prev: 'Vorige foto', next: 'Volgende foto' },
    de: { pros: 'Vorteile', cons: 'Nachteile', view: 'Produkt ansehen', close: 'Schließen', add: 'In den Warenkorb', added: 'Hinzugefügt', err: 'Hat nicht geklappt, bitte erneut', prev: 'Vorheriges Foto', next: 'Nächstes Foto' },
    fr: { pros: 'Points forts', cons: 'Points faibles', view: 'Voir le produit', close: 'Fermer', add: 'Ajouter au panier', added: 'Ajouté', err: 'Échec, réessayez', prev: 'Photo précédente', next: 'Photo suivante' },
    es: { pros: 'Ventajas', cons: 'Inconvenientes', view: 'Ver producto', close: 'Cerrar', add: 'Añadir al carrito', added: 'Añadido', err: 'No ha funcionado, inténtalo de nuevo', prev: 'Foto anterior', next: 'Foto siguiente' },
    en: { pros: 'Pros', cons: 'Cons', view: 'View product', close: 'Close', add: 'Add to cart', added: 'Added', err: 'That did not work, try again', prev: 'Previous photo', next: 'Next photo' }
  }[L] || { pros: 'Pros', cons: 'Cons', view: 'View product', close: 'Close', add: 'Add to cart', added: 'Added', err: 'That did not work, try again', prev: 'Previous photo', next: 'Next photo' };
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/');
  var cache = {};
  var sheet, panel, titleEl, body, lastFocus, closeT = 0, current = '', cur = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function build() {
    if (sheet) return;
    sheet = document.createElement('div');
    sheet.className = 'v2is';
    sheet.hidden = true;
    sheet.innerHTML = '<div class="v2is__bg" data-v2is-close></div><div class="v2is__panel" role="dialog" aria-modal="true" tabindex="-1">' +
      '<button type="button" class="v2is__x" data-v2is-close aria-label="' + esc(T.close) + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button>' +
      '<p class="v2is__title"></p><div class="v2is__body"></div></div>';
    document.body.appendChild(sheet);
    panel = sheet.querySelector('.v2is__panel');
    titleEl = sheet.querySelector('.v2is__title');
    body = sheet.querySelector('.v2is__body');
    /* pointerdown, not click: the sheet closes the moment a finger lands on the cross */
    sheet.addEventListener('pointerdown', function (e) { if (e.target.closest('[data-v2is-close]')) { e.preventDefault(); close(); } });
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-v2is-close]')) { close(); return; }
      var ga = e.target.closest('[data-v2is-ga]');
      if (ga) { var g = ga.parentNode.querySelector('.v2is__gal'); g.scrollBy({ left: +ga.getAttribute('data-v2is-ga') * Math.max(168, g.clientWidth - 60), behavior: 'smooth' }); return; }
      var v = e.target.closest('[data-v2is-v]');
      if (v && cur) { cur.sel = +v.getAttribute('data-v2is-v'); body.querySelectorAll('[data-v2is-v]').forEach(function (b) { b.setAttribute('aria-checked', String(b === v)); }); return; }
      var ad = e.target.closest('[data-v2is-add]');
      if (ad && cur) addToCart(cur, ad);
    });
  }
  /* Escape closes only the sheet: the cart drawer under it listens too and closed with it (2026-10-20 sweep). Caught on
     window in the capture phase, before the drawer, and the key's keyup is swallowed as well. */
  var escUp = false;
  function onKey(e) { if (e.key === 'Escape') { e.stopImmediatePropagation(); e.preventDefault(); escUp = true; close(); } }
  window.addEventListener('keyup', function (e) { if (e.key === 'Escape' && escUp) { escUp = false; e.stopImmediatePropagation(); e.preventDefault(); } }, true);
  function close() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('v2is-lock');
    window.removeEventListener('keydown', onKey, true);
    clearTimeout(closeT);
    closeT = setTimeout(function () { sheet.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function img480(src) {
    if (!src) return '';
    var s = String(src).replace(/([?&])width=\d+/g, '$1').replace(/[?&]+$/, '').replace(/([?&])&+/g, '$1');
    return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=480';
  }
  function list(items, kind) {
    if (!items || !items.length) return '';
    return '<div class="v2is__pc v2is__pc--' + kind + '"><p class="v2is__h">' + esc(kind === 'pro' ? T.pros : T.cons) + '</p><ul role="list">' +
      items.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div>';
  }
  function paint(o, facts, desc) {
    var pros = facts && facts.pros ? [].concat(facts.pros).filter(Boolean) : [];
    var cons = facts && facts.cons ? [].concat(facts.cons).filter(Boolean) : [];
    /* EVERY PHOTO OF THE PRODUCT (2026-10-17, asked): once the product's own data is in, all its photos sit in a row
       that swipes, every one loaded straight away (480px, small); one photo stays the single tile it always was */
    var imgs = (o.imgs && o.imgs.length > 1) ? o.imgs : (o.img ? [o.img] : []);
    /* still loading: the photo row is drawn at its final size right away (the known photo and two quiet tiles), so
       the sheet does not jump when the other photos arrive (2026-10-19, asked: "buggy when it opens" in the cart) */
    var loading = !facts;
    if (loading && imgs.length === 1) {
      body.innerHTML = '<div class="v2is__gal" role="list"><img role="listitem" class="v2is__gi" src="' + esc(img480(imgs[0])) + '" alt="" width="160" height="160"><i class="v2is__gi v2is__gi--sk"></i><i class="v2is__gi v2is__gi--sk"></i></div>' +
        '<div class="v2is__top"><div class="v2is__meta">' + (o.priceHtml ? '<p class="v2is__price">' + o.priceHtml + '</p>' : '') + '</div></div>' +
        '<div class="v2is__sk"><i></i><i></i><i></i></div>';
      return;
    }
    var gal = imgs.length > 1
      ? '<div class="v2is__galw"><div class="v2is__gal" role="list">' + imgs.map(function (u, i) { return '<img role="listitem" class="v2is__gi" src="' + esc(img480(u)) + '" alt="" width="160" height="160" loading="eager" decoding="async"' + (i ? '' : ' fetchpriority="high"') + '>'; }).join('') + '</div>' +
        /* arrows for a mouse (2026-10-27, asked: "no way to scroll images on desktop"); touch screens swipe */
        '<button type="button" class="v2is__ga v2is__ga--p" data-v2is-ga="-1" aria-label="' + esc(T.prev) + '" disabled><svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<button type="button" class="v2is__ga v2is__ga--n" data-v2is-ga="1" aria-label="' + esc(T.next) + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>'
      : '';
    var top = gal + '<div class="v2is__top">' + (!gal && imgs[0] ? '<img class="v2is__img" src="' + esc(img480(imgs[0])) + '" alt="" width="112" height="112">' : '') +
      '<div class="v2is__meta">' + (o.priceHtml ? '<p class="v2is__price">' + o.priceHtml + '</p>' : '') + '</div></div>';
    var mid = (pros.length || cons.length) ? '<div class="v2is__pcs">' + list(pros, 'pro') + list(cons, 'con') + '</div>' :
      (desc ? '<p class="v2is__desc">' + esc(desc) + '</p>' : (facts ? '' : '<div class="v2is__sk"><i></i><i></i><i></i></div>'));
    /* ADD TO CART RIGHT HERE (2026-10-27, asked: "bekijk dit product should be an add to cart button"); a product with
       several sizes shows them as chips first. The product page stays one quiet link away. */
    var vs = o.vars || [];
    var buy = '';
    if (vs.length) {
      var sel = o.sel || vs[0].id;
      /* sizes + button in one bar that sticks to the bottom of the sheet (2026-10-29, asked: "add to cart button sticky,
         always visible; variants nice and compact for mobile") */
      buy = '<div class="v2is__buy">' + (vs.length > 1 ? '<div class="v2is__vs" role="radiogroup">' + vs.map(function (v) { return '<button type="button" class="v2is__v" role="radio" aria-checked="' + (v.id === sel) + '" data-v2is-v="' + v.id + '">' + esc(v.title) + '</button>'; }).join('') + '</div>' : '') +
        '<button type="button" class="v2is__add" data-v2is-add>' + esc(T.add) + '</button></div>' +
        (o.url ? '<a class="v2is__more" href="' + esc(o.url) + '">' + esc(T.view) + '</a>' : '');
    } else if (o.url) {
      buy = '<a class="v2is__view" href="' + esc(o.url) + '">' + esc(T.view) + '</a>';
    }
    body.innerHTML = top + mid + buy;
    var g = body.querySelector('.v2is__gal');
    if (g && g.parentNode.classList.contains('v2is__galw')) { g.addEventListener('scroll', function () { galArrows(g); }, { passive: true }); requestAnimationFrame(function () { galArrows(g); }); }
  }
  function galArrows(g) {
    var w = g.parentNode, max = g.scrollWidth - g.clientWidth - 2;
    w.classList.toggle('is-flat', max <= 0);
    w.querySelector('.v2is__ga--p').disabled = g.scrollLeft <= 2;
    w.querySelector('.v2is__ga--n').disabled = g.scrollLeft >= max;
  }
  var addBusy = false;
  function addToCart(o, btn) {
    if (addBusy || !o.vars || !o.vars.length) return;
    addBusy = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    var id = o.sel || o.vars[0].id;
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var req = { items: [{ id: id, quantity: 1 }] };
    if (sections.length) { req.sections = sections.join(','); req.sections_url = ROOT + 'variants/' + id; }
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(req) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (added) {
        /* the drawer section already prints the new count, so skip the cart.js round trip when it is there */
        var m = null;
        for (var k in (added.sections || {})) { if (!m && k !== 'variant-added' && typeof added.sections[k] === 'string') m = /<cart-count[^>]*>\s*(\d+)\s*</.exec(added.sections[k]); }
        return (m ? Promise.resolve({ item_count: +m[1] }) : fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })).then(function (cart) {
          cart.sections = added.sections;
          /* the theme's quick-add contract: variant:add AND cart:change, so the drawer and the count follow */
          document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added.items || [added], cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
          try { document.dispatchEvent(new CustomEvent('lp:ui', { detail: { name: 'infosheet', action: 'add', label: o.handle, depth: 0 } })); } catch (e) {}
          btn.removeAttribute('aria-busy');
          btn.classList.add('is-done');
          btn.textContent = T.added;
          setTimeout(function () { addBusy = false; close(); }, 700);
        });
      })
      .catch(function (err) {
        addBusy = false;
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.textContent = (err && err.description) || T.err;
        setTimeout(function () { btn.textContent = T.add; }, 3000);
      });
  }
  /* a refill while the sheet is open animates its height from the old to the new instead of jumping */
  function repaint(o, facts, desc) {
    if (!panel || sheet.hidden || !sheet.classList.contains('is-open') || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { paint(o, facts, desc); return; }
    var h0 = panel.getBoundingClientRect().height;
    paint(o, facts, desc);
    var h1 = panel.getBoundingClientRect().height;
    if (Math.abs(h1 - h0) < 4) return;
    panel.style.height = h0 + 'px';
    panel.style.transition = 'height 0.28s cubic-bezier(0.2, 0.8, 0.2, 1)';
    void panel.offsetHeight;
    panel.style.height = h1 + 'px';
    var done = function () { panel.style.height = ''; panel.style.transition = ''; panel.removeEventListener('transitionend', done); };
    panel.addEventListener('transitionend', done);
    setTimeout(done, 400);
  }
  function open(o) {
    if (!o || !o.handle) return;
    build();
    current = o.handle;
    lastFocus = document.activeElement;
    titleEl.textContent = o.title || '';
    var c = cache[o.handle];
    if (c && c.imgs && c.imgs.length > 1) o.imgs = c.imgs;
    if (c && c.vars) o.vars = c.vars;
    cur = o;
    paint(o, c && c.facts, c && c.desc);
    clearTimeout(closeT);
    sheet.hidden = false;
    void sheet.offsetWidth;
    sheet.classList.add('is-open');
    document.documentElement.classList.add('v2is-lock');
    window.addEventListener('keydown', onKey, true);
    panel.scrollTop = 0;
    if (c && c.done) return;
    var pv = location.search.match(/preview_theme_id=\d+/);
    var q = pv ? '&' + pv[0] : '';
    Promise.all([
      fetch(ROOT + 'products/' + encodeURIComponent(o.handle) + '?section_id=upp-product-facts' + q).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
        var m = t && t.match(/<script type="application\/json" data-upp-facts>([\s\S]*?)<\/script>/);
        try { return m ? JSON.parse(m[1]) : {}; } catch (e) { return {}; }
      }).catch(function () { return {}; }),
      fetch(ROOT + 'products/' + encodeURIComponent(o.handle) + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
    ]).then(function (res) {
      var facts = res[0] || {}, p = res[1];
      var desc = p && p.description ? String(p.description).replace(/<style[\s\S]*?<\/style>|<script[\s\S]*?<\/script>/gi, '').replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/\s+/g, ' ').trim() : '';
      if (desc.length > 360) desc = desc.slice(0, 360).replace(/\s\S*$/, '') + '…';
      var all = p && p.images ? p.images.map(function (u) { return /^\/\//.test(u) ? 'https:' + u : u; }) : [];
      var vars = p && p.variants ? p.variants.filter(function (v) { return v.available; }).map(function (v) { return { id: v.id, title: v.title }; }) : [];
      cache[o.handle] = { facts: facts, desc: desc, done: true, imgs: all, vars: vars };
      o.vars = vars;
      if (!o.img && p && p.featured_image) o.img = p.featured_image;
      if (all.length > 1) o.imgs = all;
      if (current === o.handle && !sheet.hidden) repaint(o, facts, desc);
    });
  }
  window.swbV2InfoSheet = { open: open, close: close };

  /* A TAP IN THIS SHEET IS NOT A TAP OUTSIDE THE CART DRAWER (2026-10-19, asked: opening an add-on's info closed the cart).
     The theme's drawers and dialogs hide themselves on any click whose target they do not contain, and their focus trap
     swallows such clicks. Taught once, on the shared base: a tap inside the sheet is allowed through and closes nothing. */
  (function teach() {
    var names = ['cart-drawer', 'x-drawer', 'quick-buy-drawer', 'x-modal', 'popup-drawer'];
    var done = false;
    names.forEach(function (n) {
      var C = window.customElements && customElements.get(n);
      if (!C) return;
      var proto = C.prototype;
      while (proto && !Object.prototype.hasOwnProperty.call(proto, '_allowOutsideClick')) proto = Object.getPrototypeOf(proto);
      if (!proto || proto._allowOutsideClick.__v2is) return;
      var orig = proto._allowOutsideClick;
      proto._allowOutsideClick = function (event) {
        var t = event && event.target;
        if (t && t.closest && t.closest('.v2is')) return true;
        return orig.apply(this, arguments);
      };
      proto._allowOutsideClick.__v2is = true;
      done = true;
    });
    if (!done) setTimeout(teach, 400);
  })();

  /* the add-ons under "Hier al aan gedacht?": their (i) opens this sheet instead of the theme's drawer */
  document.addEventListener('click', function (e) {
    /* the cart drawer's add-ons too (2026-10-19): the same product opened the theme's old photo drawer there */
    var t = e.target.closest && e.target.closest('.productpage-upsells .product-info__modal, .productpage-upsells summary, .productpage-upsells [aria-controls^="x-drawer-"], cart-drawer .product-info__modal, cart-drawer [aria-controls^="x-drawer-"]');
    if (!t) return;
    var row = t.closest('[data-v2-handle]');
    if (!row) return;
    e.preventDefault();
    e.stopPropagation();
    var im = row.querySelector('img');
    var pr = row.querySelector('.cro135-price, .price-list, [class*="price"]');
    var nm = row.querySelector('.horizontal-product__info .bold, .horizontal-product__info a');
    open({
      handle: row.getAttribute('data-v2-handle'),
      url: row.getAttribute('data-v2-url'),
      title: nm ? nm.textContent.replace(/\s+/g, ' ').trim() : '',
      img: im ? (im.currentSrc || im.src) : '',
      priceHtml: pr ? pr.innerHTML : ''
    });
  }, true);
})();

/* TOOLKIT NOTES OPEN THE INFO SHEET (2026-10-20, asked: "the toolkit module on PDPs should just open the toolkit pop up
   with a description and images like the regular pop ups"). The "Toolkit required" and "Free toolkit" notes on the
   product page carry data-v2-toolkit; the link still works as a plain link without this script. */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('[data-v2-toolkit]');
  if (!a || !window.swbV2InfoSheet) return;
  e.preventDefault();
  window.swbV2InfoSheet.open({
    handle: a.getAttribute('data-v2-toolkit'),
    url: a.getAttribute('data-url') || a.getAttribute('href'),
    title: a.getAttribute('data-title') || a.textContent.trim(),
    img: a.getAttribute('data-img') || '',
    priceHtml: a.getAttribute('data-price') || ''
  });
});
